import Mark from '../node_modules/mark.js/dist/jquery.mark.es6'

jQuery(function ($) {
    let $input = $("#api_search")
    let $context = $(".api-content-item__wrap")

    $input.on("input", function () {
        let term = $(this).val()
        $context.show().unmark()
        if (term) {
            $context.mark(term, {
                done: function () {
                    $context.not(":has(mark)").hide()
                }
            })
        }
    })
})
